<div class="label" [class.error]="hasError">{{ label }}</div>
<ng-content></ng-content>
